export const WHY_GO_HUBSPOT_SECTION = 'WhyGoHubSpotSection';
export const AUTHED_APP = 'AuthedApp';
export const PHONE_SUPPORT = 'PhoneSupport';
export const INTEGRATION_TEST = 'IntegrationTest';
export const BREEZE_INTELLIGENCE_PAGE = 'BreezeIntelligencePage';
export const BREEZE_INTELLIGENCE_STARTER_PLATFORM_CARD = 'BreezeIntelligenceStarterPlatformCard';
export const RECOMMENDED_PAGE = 'RecommendedPage';
export const SMART_CRM_PAGE = 'SmartCrmPage';
export const MARKETING_PLUS_PAGE = 'MarketingPlusPage';
export const BUNDLE_PAGE = 'BundlePage';
export const SUITE_PAGE = 'SuitePage';